module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_0@3x.224f9297.png";